import f from 'fabric'
// 兼容 CDN fabric.min
const fabric = f.fabric || f
export default fabric



// WEBPACK FOOTER //
// ./src/vendor/fabric.js